import React, { useLayoutEffect } from "react";
import conoce from "../../images/planes/InteracialOldCouple.jpeg";
import "./Conoce.css";

export const Conoce: React.FC = () => {
  useLayoutEffect(() => {
    const resizeText = () => {
      const container = document.querySelector(
        ".image-container"
      ) as HTMLElement | null;
      const textOverlay = document.querySelector(
        ".text-overlay"
      ) as HTMLElement | null;
      if (container && textOverlay) {
        const containerWidth = container.offsetWidth;
        textOverlay.style.fontSize = `${containerWidth * 0.03}px`;
      }
    };

    // Aseguramos que el tamaño del texto se ajuste después del renderizado inicial
    requestAnimationFrame(resizeText);

    window.addEventListener("resize", resizeText);

    return () => {
      window.removeEventListener("resize", resizeText);
    };
  }, []);

  return (
    <div id="conoce">
      <div className="conoce-box">
        <div className="image-container">
          <div className="text-overlay">
            <p>
              Conocé todos los servicios <br />
              que ofrecemos para ayudarte <br />
              a tener una vida más <br />
              Senior Friendly
            </p>
          </div>
          <img
            src={conoce}
            alt="Old Couple"
            style={{ width: "100%", margin: "0 auto" }}
          />
        </div>
      </div>
    </div>
  );
};

export default Conoce;
